//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Linkable from "../../../mixins/Linkable";
import NavListItemMixin from "./NavListItemMixin";
import Icon from "../../Icon/Icon";
import {convertHexToRGBA, getBestContrastHexColor} from "../../../helpers/style_helpers";
import {inject as RegistrableInject} from "../../../mixins/Registrable";

export default {
    name: "NavListItem",

    mixins: [RegistrableInject('navList'), NavListItemMixin, Linkable],

    components: {Icon},

    props: {
        activeColor: {
            default: null
        },

        // Whether the item has children
        hasChildren: {
            type: Boolean,
            default: false
        },

        // The children level of the item
        // null: No styling
        // 1: Full background color on active state
        // 2: Light opacity background color on active state
        // 3: Border color on active state
        level: {
            type: Number,
            default: null
        }
    },

    computed: {

        activeColorHex() {
            return this.activeColor ? this.getColorHex(this.activeColor) : (this.level ? '#008200' : null);
        },

        textColor() {
            return this.isActive && this.activeColorHex ? getBestContrastHexColor(this.activeColorHex) : null;
        },

        style() {
            if (!this.level) {
                return {
                    color: this.isActive ? this.activeColorHex : null,
                };
            }

            switch (this.level) {
                case 1:
                    return {
                        backgroundColor: this.isActive ? this.activeColorHex : null,
                        color: this.textColor,
                        borderRadius: this.isActive && this.hasChildren ? '0 5px 0 0' : '0 5px 5px 0',
                        marginRight: '4px'
                    }
                case 2:
                    return {
                        backgroundColor: this.isActive ? convertHexToRGBA(this.activeColorHex, 0.85) : null,
                        color: this.textColor,
                        borderLeft: `4px solid ${this.activeColorHex}`,
                        marginRight: '4px'
                    }
                case 3:
                    return {
                        borderLeft: `3px solid ${this.activeColorHex}`,
                        marginRight: '4px'
                    }
                case 4:
                    return {
                        borderLeft: `2px solid ${this.activeColorHex}`,
                        marginRight: '4px'
                    }
            }

            return null;
        },

        linkProps() {
            return {
                href: this.relativeTo ? this.$router.resolve(this.relativeTo).href : this.absoluteTo,
                target: this.target,
                rel: this.target === '_blank' ? 'noopener' : null
            }
        },

        tag() {
            // We need to use native elements (no components) to correctly apply a 'click' listener
            if (this.absoluteTo || this.relativeTo) {
                return 'a';
            }

            return 'div';
        }
    },

    created() {
        this.navList && this.navList.register(this)
    },

    beforeDestroy() {
        this.navList && this.navList.unregister(this)
    },

    methods: {
        handleClick(event) {
            // When clicked on an item with a link, we want to open that link even if the item is already active, especially for parent items
            // We only deactivate linked items if their link is currently opened
            if (this.relativeTo) {
                if (this.isActive && this.$route.path === this.relativeTo) {
                    this.isActive = false;
                } else {
                    this.$router.push(this.relativeTo);
                    this.isActive = true;
                }
            } else if (this.absoluteTo) {
                const currentUrl = window.location.href;
                if (this.isActive && currentUrl === this.absoluteTo) {
                    this.isActive = false;
                } else {
                    window.open(this.absoluteTo, this.target);
                    this.isActive = true;
                }
            } else {
                this.isActive = !this.isActive;
            }
            this.$emit('click', event)
        }
    }
}
